import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { FalconTagAmend,LeafAmendmentTagView } from './Pages';

export const FalconTagAmendRoutes = ({ match }) => (
    <Fragment>
        <Route exact path = {`${match.path}`} component={FalconTagAmend} />
        <Route exact path={`${match.path}/AddEdit/:id?`} component={LeafAmendmentTagView} />
    </Fragment>
)